import { render, staticRenderFns } from "./SigninTeacher.vue?vue&type=template&id=05a0aa66&scoped=true"
import script from "./SigninTeacher.vue?vue&type=script&lang=js"
export * from "./SigninTeacher.vue?vue&type=script&lang=js"
import style0 from "./SigninTeacher.vue?vue&type=style&index=0&id=05a0aa66&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a0aa66",
  null
  
)

export default component.exports